export default {"src":"/_next/static/media/will-farell.491a768b.gif","height":500,"width":500};